import { fb as firebase } from './firebase-config'
import 'firebase/storage'

const storage = firebase.storage()
export default storage
